import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { MenuComponent } from './components/menu/menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CpfCnpjFormattedPipe } from './pipes/cpf-cnpj-pipe';
import { EllipsisDirective } from './directives/ellipsis.directive';
import { LoginComponent } from './components/login/login.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './modules/material.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module'
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [HeaderComponent, MenuComponent, CpfCnpjFormattedPipe, EllipsisDirective, LoginComponent],
  imports: [
    CommonModule,
    MaterialModule,
    BrowserAnimationsModule,
    RouterModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
    SharedModule,
    NgxSpinnerModule
  ],
  exports: [HeaderComponent, MenuComponent, CpfCnpjFormattedPipe, EllipsisDirective],
  providers: [CpfCnpjFormattedPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CoreModule {}
